module.exports = __webpack_public_path__ + "static/media/Assess-Intro.cc9f8dcb.png";